var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.modalVisualizarCadastroIsOpen
        ? _c("AppModalVisualizarCadastro", {
            attrs: { protocolo: _vm.protocolo },
            on: { closeModal: _vm.closeModalVisualizarCadastro }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.modalTrocarResponsavelIsOpen
        ? _c("TrocarResponsavel", {
            on: {
              closeModal: _vm.closeModalTrocarResponsavel,
              alterar: _vm.handleAlterarResponsavelModal
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-cadastro" },
        [
          _c(
            "div",
            { staticClass: "flex-start mt-3 mb-3" },
            [
              _c("FiltroGenerico", {
                attrs: {
                  placeholder:
                    "Pesquisar por número de processo, nome do proprietário ou CPF/CNPJ",
                  widthInput: "85%"
                },
                on: {
                  filtrosPesquisa: _vm.pesquisar,
                  limpar: _vm.limparPesquisa
                },
                scopedSlots: _vm._u([
                  {
                    key: "filtros",
                    fn: function() {
                      return [
                        _c("InputSelect", {
                          attrs: {
                            label: "Municípios:",
                            multiSelect: true,
                            opcoes: _vm.municipios
                          },
                          model: {
                            value: _vm.filtro.municipios,
                            callback: function($$v) {
                              _vm.$set(_vm.filtro, "municipios", $$v)
                            },
                            expression: "filtro.municipios"
                          }
                        }),
                        _vm._v(" "),
                        _c("InputSelect", {
                          attrs: { label: "Órgão:", opcoes: _vm.orgaos },
                          model: {
                            value: _vm.filtro.orgao,
                            callback: function($$v) {
                              _vm.$set(_vm.filtro, "orgao", $$v)
                            },
                            expression: "filtro.orgao"
                          }
                        }),
                        _vm._v(" "),
                        _c("InputSelect", {
                          attrs: {
                            label: "Responsável:",
                            opcoes: _vm.responsaveis
                          },
                          model: {
                            value: _vm.filtro.responsavel,
                            callback: function($$v) {
                              _vm.$set(_vm.filtro, "responsavel", $$v)
                            },
                            expression: "filtro.responsavel"
                          }
                        })
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("BaseTable", {
            attrs: {
              title: "Listagem",
              tableData: _vm.processos,
              columns: [
                {
                  key: "numeroProcesso",
                  label: "N° Processo",
                  width: "200rem"
                },
                {
                  key: "cpfCnpjProprietario",
                  label: "CPF/CNPJ",
                  width: "200rem"
                },
                {
                  key: "nomeRazaoSocialProprietario",
                  label: "Proprietário/Razão social"
                },
                { key: "status.nome", label: "Status", align: "center" },
                { key: "municipio", label: "Município" },
                { key: "nomeResponsavel", label: "Responsável" },
                { key: "orgao", label: "Órgão" },
                { key: "actions", label: "Ações", align: "center" }
              ],
              pagination: {
                show: true,
                pageSize: _vm.filtro.tamanhoPagina,
                totalPages: _vm.totalPages,
                totalElements: _vm.totalElements
              }
            },
            on: { pageChange: _vm.changePage }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05fb1f60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05fb1f60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/analise/sala-monitoramento/caixa-entrada/caixa-entrada.vue
// module id = null
// module chunks = 